import React from 'react';
import { Checkbox, Col, Row } from 'antd';
import { Permission } from '../dto';

interface PermissionSelectProps {
  permissionsEnum: typeof Permission;
  value: Permission[];
  onChange: (values: Permission[]) => void;
}

const PermissionSelect: React.FC<PermissionSelectProps> = ({
  permissionsEnum,
  value,
  onChange,
}) => {
  // Instead of Object.values, use Object.entries to get [key, value] pairs
  const permissionOptions = Object.entries(permissionsEnum);

  const handleCheckboxChange = (checkedValues: any[]) => {
    onChange(checkedValues as Permission[]);
  };

  return (
    <div className="p-4 border rounded-md shadow-sm">
      <Checkbox.Group
        style={{ width: '100%' }}
        value={value}
        onChange={handleCheckboxChange}
      >
        <Row gutter={16}>
          {permissionOptions.map(([label, val]) => (
            <Col key={val} span={12}>
              <div className="mb-5">
                {/* Use val for the value, and label (key name) for display */}
                <Checkbox value={val}>{label}</Checkbox>
              </div>
            </Col>
          ))}
        </Row>
      </Checkbox.Group>
    </div>
  );
};

export default PermissionSelect;
